import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Employee } from 'src/app/shared/models/employee/employee';
import { Authority } from 'src/app/shared/models/security/authority';
import { User } from 'src/app/shared/models/security/user';
import { FacadeService } from '../../services/facade.service';

@Component({
	selector: 'app-sidebar',
	templateUrl: './sidebar.component.html',
	styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
	/* Listing des liens accessibles depuis le menu */
	menuItems: {
		name: string;
		path: string;
		parentPath: string;
		iconClass: string;
        sub_menu: {
            name: string;
		    path: string;
		    parentPath: string;
        }[]
	}[] = [];

	/**
	 * Id du profile de l'utilisateur
	 */
	authorityId: number;
	isIntervenant = false;
	isAdmin = false;
	isManager = false;
	currentUserLoggedIn: User;

	/* Toggle de la side navbar */
	@Input() isSidebardHidden: boolean = true;
	@Output() toggleSidebarPinEmitter: EventEmitter<any> = new EventEmitter();

	constructor(private facade: FacadeService, protected router: Router) {}

	ngOnInit(): void {
		const user: User = this.facade.dataStorageService.getUser();
		this.isIntervenant = this.facade.dataStorageService.isIntervenant();
		this.isAdmin = this.facade.dataStorageService.isAdmin();
		this.isManager = this.facade.dataStorageService.isManager();

		this.currentUserLoggedIn = user;

		this.initNavbar();
	}

	/**
	 * Initialise les éléments du tableau représentant la navbar
	 * @param authority id du profile
	 */
	initNavbar(): void {
		if (this.authorityId === null || this.authorityId === 0) {
			this.authorityId = this.facade.dataStorageService.getUser()?.profile.id;
		}
		const hasAccessToData: boolean = true;
			//this.authorityId === Authority.PLANIFICATEUR ||
			//this.authorityId === Authority.CHARGE_MISSION;


		if (hasAccessToData) {
			this.menuItems.push({
				name: 'Tableau de bord',
				path: '/dashboard',
				parentPath: '/dashboard',
				iconClass: 'bi bi-house-door-fill',
                sub_menu: []
			});
			this.menuItems.push({
				name: 'Bénéficiaires',
				path: '/beneficiaires/list',
				parentPath: '/beneficiaires/list',
				iconClass: 'bi bi-person-fill',
                sub_menu: []
			});
			this.menuItems.push({
				name: 'Prestations',
				path: '/prestation/appuis-specifiques',
				parentPath: '/prestation',
				iconClass: 'bi bi-folder2-open',
                sub_menu: []
			});
			if(!this.isIntervenant){
				this.menuItems.push({
					name: 'Administration',
					path: '/gestion/users',
					parentPath: '/gestion',
					iconClass: 'bi bi-pencil-square',
					sub_menu: []
				});
			}
			if(this.isAdmin || this.isManager){
				this.menuItems.push({
					name: 'Paramétrage',
					path: '/parametrage/amenagement',
					parentPath: '/parametrage',
					iconClass: 'bi bi-gear-fill',
					sub_menu: []
				});
			}
			if(!this.isIntervenant){
				this.menuItems.push({
					name: 'Système',
					path: '/systeme/systeme/form',
					parentPath: '/systeme/systeme',
					iconClass: 'bi bi-wrench',
					sub_menu: []
				});
			}
		}

        if (hasAccessToData /*&& !this.facade.dataStorageService.isSSIAD()*/) {
			// this.menuItems.push({
			// 	name: 'Utilisateurs',
			// 	path: '/users',
			// 	parentPath: '/users',
			// 	iconClass: 'bi bi-person-fill',
            //     sub_menu: [
			// 		{
            //             name: 'Utilisateurs',
			// 	        path: '/users',
			// 	        parentPath: '/users'
            //         },
            //         {
            //             name: 'Rôles',
			// 	        path: '/users',
			// 	        parentPath: '/users'
            //         },
            //         {
            //             name: 'Bénéficiaires',
			// 	        path: '/users',
			// 	        parentPath: '/users'
            //         }
            //     ]
			// });
		}
	}

	toggleSidebarPin() {
		this.toggleSidebarPinEmitter.emit();
	}

    showHideSubmenu(itemEl: HTMLElement) {
        if(itemEl.childNodes[1].childNodes[0].childNodes[2]["style"]["display"] === "none"){
            itemEl.childNodes[1].childNodes[0].childNodes[3]["style"]["display"] = "none";
            itemEl.childNodes[1].childNodes[0].childNodes[2]["style"]["display"] = "block";
            itemEl.childNodes[3]["style"]["display"] = "none";
        }else{
            itemEl.childNodes[1].childNodes[0].childNodes[3]["style"]["display"] = "block";
            itemEl.childNodes[1].childNodes[0].childNodes[2]["style"]["display"] = "none";
            itemEl.childNodes[3]["style"]["display"] = "block";
        }
    }
}
